























































































import { Component, Vue } from 'vue-property-decorator';
import BaseVue from '@/core/BaseVue';
import GenericEdit from '@/core/Generics/GenericEdit';
import ProjectType from "@/models/porposal/projectType.Model";
@Component
export default class MemberTypeEdit extends GenericEdit<ProjectType> {
  constructor() {
    super();
    this.controller = 'ProjectTypes';
    this.model = new ProjectType();
  }
}
